import { defineMessages } from 'react-intl';

export default defineMessages({

    selectVehicleTitle: {
        id: 'ml.quoteandbind.pa.vehicledetails.addVehicle.Select Vehicle',
        defaultMessage: 'Select Vehicle'
    },

    symbolsPopupMsg: {
        id: 'ml.quoteandbind.pa.vehicledetails.addVehicle.symbolsPopupMsg',
        defaultMessage: 'Comp: {compSymbol} {br}Collision: {collSymbol}'
    }
});